import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Fraction } from "../../data/fractions/types";
import * as dataActions from "../../data/fractions";

const prefix = "app/fraction-dialog";

export type FormData = {
  id?: string;
  name: string;
  code: string | null;
  color: string | null;
  unit: string;
  eakCode: string | null;
  productId: string | null;
  salesPrice: string | null;
};

type State = { open: boolean; initialFormData: FormData | null };
const initialState: State = { open: false, initialFormData: null };

export const getEmptyFormData = (): FormData => ({
  name: "",
  code: null,
  color: null,
  unit: "kg",
  eakCode: null,
  productId: null,
  salesPrice: null,
});

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    addFraction(state) {
      state.open = true;
      state.initialFormData = getEmptyFormData();
    },
    editFraction(state, action: PayloadAction<Fraction>) {
      state.open = true;
      state.initialFormData = { ...action.payload };
    },
    close(state) {
      state.open = false;
      state.initialFormData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(dataActions.addFraction.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
    builder.addCase(dataActions.updateFraction.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
  },
});

export default slice.reducer;
export const { addFraction, editFraction, close } = slice.actions;
export const selectFractionDialogOpen = (s: {
  app: { fractionDialog: State };
}) => s.app.fractionDialog.open;
export const selectFractionDialogData = (s: {
  app: { fractionDialog: State };
}) => s.app.fractionDialog.initialFormData;
